import React from 'react'
import { Stack } from 'expo-router'
import { Pressable, View, Text } from 'react-native'
import { TurnActionCounter } from '../../../components/turn/TurnActionCounter'
import { useTheme } from '../../../hooks/useTheme'

/** Offline typography/contrast QA with the production phase counter. */
export default function TurnCountersPreview() {
  const { toggleTheme } = useTheme()
  return (
    <View className="flex-1 bg-canvas p-4 gap-4">
      <Stack.Screen options={{ title: 'Turn counters' }} />
      <Pressable accessibilityRole="button" accessibilityLabel="Toggle theme" onPress={toggleTheme}>
        <Text className="text-ink">Toggle theme</Text>
      </Pressable>
      {([0, 1, 5] as const).map(used => (
        <View key={used} testID={`used-${used}`} className="gap-3">
          {(['attacks', 'fortifies'] as const).map(action => (
            <View key={action} className="flex-row gap-4">
              <TurnActionCounter action={action} used={used} limit={5} compact />
              <TurnActionCounter action={action} used={used} limit={null} compact />
            </View>
          ))}
        </View>
      ))}
    </View>
  )
}
